import { useMemo } from "react";
import { withNamespaces } from "react-i18next";
import { Spinner } from "reactstrap";
import DataFlowGraph from "src/modules/data-protection/components/data-flow-graph";
import buildVisualMapGraph from "../helpers/buildVisualMapGraph";

const DataFlowVisualMap = ({
    softwareName,
    incomingCards = [],
    outgoingCards = [],
    methodLabels = {},
    typeLabels = {},
    relationLabels = {},
    isLoading = false,
    t,
}) => {
    const graph = useMemo(
        () =>
            buildVisualMapGraph({
                softwareName,
                incomingCards,
                outgoingCards,
                methodLabels,
                typeLabels,
                relationLabels,
                t,
            }),
        [
            incomingCards,
            methodLabels,
            outgoingCards,
            relationLabels,
            softwareName,
            t,
            typeLabels,
        ]
    );
    const graphRevision = useMemo(
        () =>
            [...incomingCards, ...outgoingCards]
                .map((card) =>
                    [
                        card.id,
                        card.counterpart?.id,
                        card.counterpart?.name,
                        card.relation,
                        (card.methods || []).join(","),
                        (card.dataTypes || []).join(","),
                    ].join(":")
                )
                .join("|"),
        [incomingCards, outgoingCards]
    );

    return (
        <div className="data-flow-v2__map">
            <div className="data-flow-v2__map-header">
                <div className="data-flow-v2__map-title">
                    <i className="ri-share-line me-2" aria-hidden="true" />
                    {t("Data Flow Network")}
                </div>
                <div className="data-flow-v2__map-dots">
                    <span className="data-flow-v2__map-dot data-flow-v2__map-dot--incoming">
                        {t("Incoming")}
                    </span>
                    <span className="data-flow-v2__map-dot data-flow-v2__map-dot--outgoing">
                        {t("Outgoing")}
                    </span>
                    <span className="data-flow-v2__map-dot data-flow-v2__map-dot--central">
                        {t("Central")}
                    </span>
                </div>
            </div>
            {isLoading ? (
                <div className="data-flow-v2__map-empty text-muted">
                    <Spinner size="sm" className="me-2" />
                    {t("Loading...")}
                </div>
            ) : graph ? (
                <DataFlowGraph
                    key={graphRevision}
                    graph={graph}
                    height={520}
                    className="data-flow-v2__map-canvas"
                    showFitView
                    showMapLegend
                />
            ) : (
                <div className="data-flow-v2__map-empty text-muted text-center">
                    {t("No data flows added yet.")}
                </div>
            )}
        </div>
    );
};

export default withNamespaces()(DataFlowVisualMap);
